import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobileAlt, faWallet, faMoneyBill, faPhone } from '@fortawesome/free-solid-svg-icons';

const PaiementDetail = ({ paiement }) => {

const getStatusLabel = (status) => {

    switch (status) {
        case 0:
            return { text: "En attente", color: "text-gray-800 bg-gray-600 text-lg text-gray-700 font-bold rounded-xl px-4 py-1 text-sm bg-opacity-15" };
        case 1:
            return { text: "Payé", color: "text-green-800 bg-green-600 text-lg text-green-700 font-bold rounded-xl px-4 py-1 text-sm bg-opacity-15" };
        
        default:
            return { text: "Inconnu", color: "text-red-800 bg-red-600 animate-ping text-lg text-red-700 font-bold rounded-xl px-4 py-1 text-sm bg-opacity-15" };
    }
};
    
  return (
    <div className="w-full p-6 mx-auto bg-white rounded-lg shadow-lg dark:bg-gray-800">
      
      {/* Titre du paiement */}
      <h2 className="mb-4 text-2xl font-bold text-gray-800 dark:text-gray-200">Détails du Paiement</h2>

      {/* Détails du paiement */}
      <div className="pb-4 mb-4 border-b">
        <p className="text-lg font-semibold text-gray-600 dark:text-gray-200">Référence du paiement : {paiement.id}</p>
        
        <p className={`text-lg text-gray-800 dark:text-gray-200`}>Statut : <span className={`${getStatusLabel(paiement.status).color}`}>{getStatusLabel(paiement.status).text}</span></p>
        <p className="text-lg text-gray-600 dark:text-gray-200">Date : {new Date(paiement.createdAt).toLocaleDateString()}</p>
      </div>

      {/* Détails de la transaction mobile money */}
      {paiement.transaction && 
        <div className="pb-4 mb-4 border-b">
          <h3 className="mb-2 text-xl font-semibold text-gray-800 dark:text-gray-200">Transaction Mobile Money</h3>
          <div className="flex items-center mb-2">
              <FontAwesomeIcon icon={faMobileAlt} className="mr-2 text-indigo-600" />
              <p className="text-gray-600 dark:text-gray-200">Numéro de transaction : {paiement.transaction.XReference}</p>
          </div>
          <div className="flex items-center mb-2">
              <FontAwesomeIcon icon={faWallet} className="mr-2 text-indigo-600" />
              <p className="text-gray-600 dark:text-gray-200">Opérateur : {paiement.transaction.operator ? paiement.transaction.operator : 'MTN'}</p>
          </div>
          <div className="flex items-center">
              <FontAwesomeIcon icon={faMoneyBill} className="mr-2 text-indigo-600" />
              <p className="text-green-600 dark:text-gray-200 ">
                Montant payé : 
                <span> {paiement.transaction.amount} </span> 
                <span>{paiement.transaction.currency}</span>
              </p>
          </div>

          <div className="flex items-center my-2">
              <FontAwesomeIcon icon={faPhone} className="mr-2 text-indigo-600" />
              <p className="text-gray-600 dark:text-gray-200">
                Telephone : 
                <span> {paiement.transaction.msisdn} </span> 
              </p>
          </div>
        </div>
      }

      {/* Détails de la distribution */}
      {(paiement.transaction && paiement.distribution) && <div className="mb-4">
        <h3 className="mb-2 text-xl font-semibold text-gray-800 dark:text-gray-200">Distribution des fonds</h3>
        <div className="mb-2">
          <p className="text-gray-600 dark:text-gray-200">Part de l'application : 
            <span className='mx-1 font-bold text-green-600 dark:text-green-600'>
              {paiement.distribution.commission} % ({(paiement.distribution.commission * paiement.transaction.amount) / 100}) {paiement.transaction.currency}
            </span>
          </p>
        </div>
        <div className="mb-2">
          
          <p className="text-gray-600 dark:text-gray-200">Part du proprietaire : 
            <span className='mx-1 font-bold text-green-600 dark:text-green-600'>
               {( paiement.transaction.amount - (paiement.distribution.commission * paiement.transaction.amount) / 100)}
              
            </span >

            <span className='font-bold text-green-600 dark:text-green-600'>
               {paiement.transaction.currency}
            </span>
          </p>
          
        </div>
        
      </div>}

      
    </div>
  );
};


export default PaiementDetail
